import { OrganizationType } from '../../interfaces/organizations';
import type { GlobalState } from '../index';

export const selectServerFilters = (state: GlobalState) => state.filters.serverFilters;
export const selectServerFiltersByType = (type: OrganizationType) => (state: GlobalState) =>
  state.filters.serverFilters[type];
export const selectProductsTags = (state: GlobalState) => state.filters.productsTags;
